import { render, staticRenderFns } from "./dialog-DISC.vue?vue&type=template&id=61447a80&scoped=true"
import script from "./dialog-DISC.vue?vue&type=script&lang=ts"
export * from "./dialog-DISC.vue?vue&type=script&lang=ts"
import style0 from "./dialog-DISC.vue?vue&type=style&index=0&id=61447a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61447a80",
  null
  
)

export default component.exports